<template>
  <div class="container-fluid">
    <main-header></main-header>
    <!-- 본인인증 -->
    <mobile-validation-point @current-page="receiveData" v-if="currentPage === 'intro'"></mobile-validation-point>
    <!-- 예치금 출금 전용 회원가입 -->
    <join-point-calculate @current-page="receiveData" v-if="currentPage === 'hmm'"></join-point-calculate>
    <!-- 완료화면 -->
    <completion-screen-point v-if="currentPage === 'fin'"></completion-screen-point>
  </div>
</template>

<script>
/**
 * 빽통 예치금 정산 목록로 초대된 회원가입 프로세스
 */

import MainHeader from "@/views/MainHeader.vue";
import JoinPointCalculate from "@/views/join/JoinPointCalculate.vue";
import CompletionScreenPoint from "@/views/finish/CompletionScreenPoint.vue";
import MobileValidationPoint from "@/views/MobileValidationPoint.vue";

export default {
  name: "JoinPointContainer",
  components: {
    MobileValidationPoint,
    CompletionScreenPoint,
    JoinPointCalculate,
    MainHeader
  },
  data(){
    return {
      currentPage:this.$store.getters.getCurrentPage,
    }
  },
  mounted() {
  },
  methods: {
    receiveData(step){
      this.currentPage = step.page;
    }
  }
}
</script>

<style scoped>

</style>